import React from 'react';

const ShipmentIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            width="1em"
            height="1em"
            fill="currentColor"
            {...props}
        >
            <path d="M1.66675 2.5H18.3334V5.83333H1.66675V2.5ZM15.8334 6.66667H2.50008V15.8333C2.50008 16.2754 2.67568 16.6993 2.98824 17.0118C3.3008 17.3244 3.72472 17.5 4.16675 17.5H15.8334C16.2754 17.5 16.6994 17.3244 17.0119 17.0118C17.3245 16.6993 17.5001 16.2754 17.5001 15.8333V6.66667H15.8334ZM13.3334 11.6667H6.66675V10H13.3334V11.6667Z" />
        </svg>
    );
};

export default ShipmentIcon;
